export default __webpack_public_path__ + "static/media/karachi.1ee76790.jpg";